import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="line-items"
export default class extends Controller {
  static targets = ["container", "template"]

  connect() {
    this.itemIndex = this.containerTarget.children.length
  }

  add(event) {
    event.preventDefault()
    
    const template = this.templateTarget.innerHTML
    const newIndex = this.itemIndex++
    
    // Replace the placeholder index with actual index
    const newItem = template.replace(/NEW_RECORD/g, newIndex)
    
    // Create a wrapper div
    const wrapper = document.createElement('div')
    wrapper.innerHTML = newItem
    
    this.containerTarget.appendChild(wrapper.firstElementChild)
  }

  remove(event) {
    event.preventDefault()
    
    const item = event.target.closest('[data-line-item]')
    if (item) {
      // If this is an existing item, mark it for deletion
      const destroyInput = item.querySelector('input[type="hidden"][name*="_destroy"]')
      if (destroyInput) {
        destroyInput.value = "1"
        item.style.display = "none"
      } else {
        // If it's a new item, just remove it
        item.remove()
      }
    }
  }
}